import React from "react";

const RadioVerticalGroup = ({
  label,
  required = true,
  name,
  currentValue,
  radios = [],
  onChange,
}) => {
  return (
    <div className="w-[340px]">
      {label && (
        <label className={`label${required ? " req" : ""}`} htmlFor={name}>
          {label}
        </label>
      )}
      <div className="list-wrapper">
        {radios.map((radio) => {
          const value = radio.value ? radio.value : radio;
          const label = radio.label ? radio.label : radio;
          return [
            <div>
              <input
                name={name}
                id={value}
                type="radio"
                value={value}
                onChange={onChange}
                checked={currentValue === value}
              />
              <p className="p1">{label}</p>
            </div>,
          ];
        })}
      </div>
    </div>
  );
};

export default RadioVerticalGroup;
